module.exports = __webpack_public_path__ + "static/media/drag-icon.08f8524e.svg";